module.exports = __webpack_public_path__ + "static/media/ax.430ca7cc.svg";